<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--p-Table w/ buttons-->
<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
                    [(ngModel)]="SelectedSchoolID"
                    (ngModelChange)="onSchoolChange($event)">
                    <option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
                </select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading" class="btn btn-primary customButton" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button [disabled]="loading" class="btn btn-primary customButton" style="margin-left: 0px" (click)="onAddTrigger()">Add Trigger</button>
		<button [disabled]="loading" class="btn btn-primary customButton" style="margin-left: 5px" (click)="onViewDetails()">View Details</button>
		<button [disabled]="loading" class="btn btn-primary customButton" style="margin-left: 0px" (click)="onResetTrigger()">Reset Trigger</button>
		<button [disabled]="loading" class="btn btn-primary customButton" style="margin-left: 0px" (click)="onToggleTrigger()">Deactivate Trigger</button>
		<button [disabled]="loading" class="btn btn-primary customButton" style="margin-left: 0px" (click)="onRemoveTrigger()">Remove Trigger</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstTriggers"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedTrigger"
		dataKey="ActionTriggerID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th>
					<p-columnFilter field="ActionTriggerType" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActionTriggerType
								[ngModel]="value"
								[options]="lstActionTriggerType"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
				<th>
					<p-columnFilter field="TriggeredFor" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterTriggeredFor
								[ngModel]="value"
								[options]="lstTriggeredFor"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
				<th>
					<p-columnFilter field="ActionType" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActionType
								[ngModel]="value"
								[options]="lstActionType"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
				<th>
					<p-columnFilter field="Action" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAction
								[ngModel]="value"
								[options]="lstAction"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
				<th>
					<p-columnFilter type="numeric" field="TriggerValue" [showMenu]="true"></p-columnFilter>
				</th>
				<th>
					<p-columnFilter field="Active" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActive
								[ngModel]="value"
								[options]="lstActive"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="ActionTriggerType">Action Trigger Type<p-sortIcon field="ActionTriggerType"></p-sortIcon></th>
				<th pSortableColumn="TriggeredFor">Triggered For<p-sortIcon field="TriggeredFor"></p-sortIcon></th>
				<th pSortableColumn="ActionType">Action Type<p-sortIcon field="ActionType"></p-sortIcon></th>
				<th pSortableColumn="Action">Action<p-sortIcon field="Action"></p-sortIcon></th>
				<th pSortableColumn="TriggerValue">Value<p-sortIcon field="TriggerValue"></p-sortIcon></th>
				<th pSortableColumn="Active">Active<p-sortIcon field="Active"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-trigger>
			<tr [pSelectableRow]="trigger" (dblclick)="onRowDblClick(trigger)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ trigger[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="form-group TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
